const xuanhuan = {
  category: '玄幻',
  categoryId: '3',
  coverList: [
    {
      coverId: 3001,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FEFEFF',
        smallTitleColor: '#000',
        smallTitleBackground: '#D82323',
        color_mask: '#A7BCC7',
        font: '山海手书',
        fontSize: '77',
        strokeColor: '#000',
        spacing: -10,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xuanhuan/1-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #000)',
      },
    },
    {
      coverId: 3002,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FEFEFF',
        smallTitleColor: '#000',
        smallTitleBackground: '#D82323',
        color_mask: '#A7BCC7',
        font: '山海手书',
        fontSize: '77',
        strokeColor: '#000',
        spacing: -10,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xuanhuan/2-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #000)',
      },
    },
    {
      coverId: 3003,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FEFEFF',
        smallTitleColor: '#000',
        smallTitleBackground: '#D82323',
        color_mask: '#A7BCC7',
        font: '山海手书',
        fontSize: '77',
        strokeColor: '#000',
        spacing: -10,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xuanhuan/3-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #000)',
      },
    },
    {
      coverId: 3004,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FEFEFF',
        smallTitleColor: '#000',
        smallTitleBackground: '#D82323',
        color_mask: '#A7BCC7',
        font: '山海手书',
        fontSize: '77',
        strokeColor: '#000',
        spacing: -10,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xuanhuan/4-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #000)',
      },
    },
    {
      coverId: 3005,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FEFEFF',
        smallTitleColor: '#000',
        smallTitleBackground: '#D82323',
        color_mask: '#A7BCC7',
        font: '山海手书',
        fontSize: '77',
        strokeColor: '#000',
        spacing: -10,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xuanhuan/5-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #000)',
      },
    },
    {
      coverId: 3006,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FEFEFF',
        smallTitleColor: '#000',
        smallTitleBackground: '#D82323',
        color_mask: '#A7BCC7',
        font: '山海手书',
        fontSize: '77',
        strokeColor: '#000',
        spacing: -10,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xuanhuan/6-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #000)',
      },
    },
    {
      coverId: 3007,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FEFEFF',
        smallTitleColor: '#000',
        smallTitleBackground: '#D82323',
        color_mask: '#A7BCC7',
        font: '山海手书',
        fontSize: '77',
        strokeColor: '#000',
        spacing: -10,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xuanhuan/7-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #000)',
      },
    },
    {
      coverId: 3008,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FEFEFF',
        smallTitleColor: '#000',
        smallTitleBackground: '#D82323',
        color_mask: '#A7BCC7',
        font: '山海手书',
        fontSize: '77',
        strokeColor: '#000',
        spacing: -10,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/xuanhuan/8-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #000)',
      },
    },
  ],
};

export default xuanhuan;
